import * as z from "zod";

export const SESSION_PATH = "/api/session";
export const READER_SESSION_PATH = "/reader-session";

// A bookmark landing names the reader the Worker signed in, so the SPA can
// mark it unconfirmed before (and whether or not) the session read answers.
export const VIA_PARAM = "via";
export const VIA_BOOKMARK = "bookmark";
export const GATE_PARAM = "gate";
// The app returning to the device's own last reader: identify-only like a
// bookmark, but not a scan, so it lands ungated.
export const VIA_DEVICE = "device";

// `serverTime` (epoch ms) lets the client measure its clock skew for
// bookmark timestamps without a second request. `linked` says whether any
// account holds the reader; null when the token cannot say (minted before
// the claim, or the broker could not read it) or no reader is named.
// `isAide` is never true for a reader_session: a reader token carries no
// credential, so it can never vouch for a staff role.
export const sessionAnswerSchema = z.discriminatedUnion("lane", [
  z.object({
    lane: z.literal("reader_session"),
    readerId: z.uuid(),
    linked: z.boolean().nullable(),
    isAide: z.literal(false),
    serverTime: z.number(),
  }),
  z.object({
    lane: z.literal("user_session"),
    readerId: z.uuid().nullable(),
    linked: z.boolean().nullable(),
    isAide: z.boolean(),
    serverTime: z.number(),
  }),
]);

export type SessionAnswer = z.infer<typeof sessionAnswerSchema>;
